import { render, staticRenderFns } from "./CustomTopic.vue?vue&type=template&id=0ccf624e&"
import script from "./CustomTopic.vue?vue&type=script&lang=js&"
export * from "./CustomTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports